<template>
  <div class="login-container" v-if="!isLoggedIn" @click.self="closeLogin">
    <div class="login-card">
      <button class="close-button" @click="closeLogin">×</button>
      <h2 class="welcome-text">登录开刷！</h2>
      <div class="login-form">
        <div v-if="loginMode === 'code'" class="form-group">
          <div class="input-group">
            <select v-model="countryCode" class="country-select">
              <option value="+86">+86</option>
              <option value="+1">+1</option>
              <option value="+44">+44</option>
            </select>
            <input 
              type="text" 
              placeholder="手机号" 
              v-model="phone_num" 
              @keydown.enter="submit"
              @input="validatePhone"
              class="phone-input"
              :class="{ 'error': !isPhoneValid && phone_num.length > 0 }"
            />
          </div>
          
          <div class="input-group verification-group">
            <input 
              type="text" 
              placeholder="6位数字验证码" 
              v-model="verificationCode" 
              @keydown.enter="submit"
              class="verification-input"
              :class="{ 'error': codeError }"
            />
            <button
              id="sendButton"
              class="verify-button" 
              @click="triggerCaptcha"
              :disabled="!isPhoneValid || isCounting"
              :class="{ 'disabled': !isPhoneValid || isCounting }"
            >
              {{ isCounting ? `${countdown}s` : '获取验证码' }}
            </button>
          </div>
          
          <button 
            @click="submit" 
            class="submit-button"
            :disabled="!isFormValid"
            :class="{ 'disabled': !isFormValid }"
          >
            登录（注册）
          </button>
        </div>

        <div v-if="loginMode === 'password'" class="form-group">
          <div class="input-group">
            <select v-model="countryCode" class="country-select">
              <option value="+86">+86</option>
              <option value="+1">+1</option>
              <option value="+44">+44</option>
            </select>
            <input 
              type="text" 
              placeholder="手机号" 
              v-model="phone_num"
              @input="validatePhone"
              class="phone-input"
              :class="{ 'error': !isPhoneValid && phone_num.length > 0 }"
            />
          </div>

          <div class="input-group password-group">
            <input 
              :type="showPassword ? 'text' : 'password'" 
              placeholder="密码" 
              v-model="password"
              class="password-input"
              :class="{ 'error': passwordError }"
            />
            <span 
              class="password-toggle"
              @click="togglePasswordVisibility"
            >
              {{ showPassword ? '隐藏' : '显示' }}
            </span>
          </div>

          <button 
            @click="login_phone" 
            class="submit-button"
            :disabled="!isPasswordFormValid"
            :class="{ 'disabled': !isPasswordFormValid }"
          >
            登录
          </button>
        </div>

        <div class="login-options">
          <button 
            @click="toggleLoginMode" 
            class="toggle-mode-button"
          >
            {{ loginMode === 'code' ? '使用手机号/密码登录' : '使用验证码登录' }}
          </button>
          
          <!-- <div class="social-login">
            <p class="social-text">其他登录方式</p>
            <div class="social-icons">
              <svg class="icon contact-icon" aria-hidden="true" @click="qqLogin">
                <use xlink:href="#icon-QQ"></use>
              </svg>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import EventBus from '@/utils/eventBus.js'

export default {
  data() {
    return {
      isCounting: false,
      countdown: 60,
      timer: null,
      phone_num: '',
      verificationCode: '',
      password: '',
      loginMode: 'code',
      isLoggedIn: false,
      countryCode: '+86',
      showPassword: false,
      phoneError: '',
      codeError: '',
      passwordError: '',
      captcha: null,
    };
  },
  computed: {
    isPhoneValid() {
      const phoneRegex = /^\d{11}$/;
      return phoneRegex.test(this.phone_num);
    },
    isFormValid() {
      return this.isPhoneValid && this.verificationCode.length === 6;
    },
    isPasswordFormValid() {
      return this.isPhoneValid && this.password.length >= 6;
    }
  },
  async mounted(){
    await this.checkLoginStatus();
    await this.getCode();
    // 确保DOM已经渲染完成后再初始化验证码
    this.$nextTick(() => {
      window.initAliyunCaptcha({
        SceneId: '1lyvqmpn',
        prefix: '1pi66g',
        mode: 'popup',
        element: '#captcha-element',
        button: '#sendButton',
        captchaVerifyCallback: this.captchaVerifyCallback,
        onBizResultCallback: this.onBizResultCallback,
        getInstance: this.getInstance,
        slideStyle: {
          width: 360,
          height: 40,
        },
        language: 'cn',
      });
    });
  },
  beforeUnmount() {
    document.getElementById('aliyunCaptcha-mask')?.remove();
    document.getElementById('aliyunCaptcha-window-popup')?.remove();
  },
  methods: {
    closeLogin() {
      this.$emit('close');
    },
    async checkLoginStatus() {
       // 判断用户是否登录，先获取token，如果token不存在则未登录，否则尝试获取用户信息，如果获取用户信息失败则未登录
       var token = localStorage.getItem('token');
        if(token){
          try {
            const userInfoRes = await api.userInfo();
            if (userInfoRes.status === 200) {
              if(userInfoRes.data.code === 0){
                this.isLoggedIn = true;
                this.user = userInfoRes.data.data;
              } else {
                this.isLoggedIn=false;
                // 跳转到登录页面
                this.$message({
                  message: '请先登录',
                  type: 'warning'
                });
              }
            } else {
              this.isLoggedIn = false;
            }
          } catch (error) {
            console.log(error);
            this.isLoggedIn = false;
          }
        } else {
          this.isLoggedIn = false;
        }
    },
    async getCode() {
      let code = this.$route.query.code;
      await this.checkLoginStatus();
      if (code) {
        if(this.isLoggedIn){
          // 此时用户是登录状态，应该是绑定QQ的过程
          let response = await api.bindQQ({ code });
          // 绑定QQ成功
          if (response.data.code === 0) {
            this.$message({
              message: '绑定QQ成功',
              type: 'success'
            });
            this.$router.push('/user/info');
          } else {
            this.$message({
              message: response.data.msg || '绑定QQ失败',
              type: 'error'
            });
          }
        }else{
          let response = await api.qqLogin({ code });
          if (response.data.code === 0) {
            localStorage.setItem('token', response.data.data.token);
            EventBus.emit('user-logged-in');
            this.$router.push('/');
          } else {
            this.$message({
              message: response.data.msg || 'QQ登录失败',
              type: 'error'
            });
          }
        }
      }else{
        if(this.isLoggedIn){
          // 此时用户是登录状态，为用户强制进入/login页面
          this.$router.push('/');
        }
      }
    },
    triggerCaptcha() {
      if (this.captcha) {
        this.captcha.show();
      } else {
        window.initAliyunCaptcha({
          SceneId: '1lyvqmpn',
          prefix: '1pi66g',
          mode: 'popup',
          element: '#captcha-element',
          button: '#sendButton',
          captchaVerifyCallback: this.captchaVerifyCallback,
          onBizResultCallback: this.onBizResultCallback,
          getInstance: this.getInstance,
          slideStyle: {
            width: 360,
            height: 40,
          },
          language: 'cn',
        });
      }
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      var verifyResult = {
        captchaResult: false,
        bizResult: false,
      };
      captchaVerifyParam = JSON.parse(captchaVerifyParam);
      await api.send_sms({ captcha_verify_param : captchaVerifyParam, phone_num: this.phone_num }) 
        .then(response => {
          if(response.data.code === 0){
            verifyResult.bizResult = true;
            verifyResult.captchaResult = response.data.data.captcha_verify_result;
          }
        });

      if (verifyResult.captchaResult && verifyResult.bizResult) {
        await this.sendSms(verifyResult.captchaResult);
      }
      return verifyResult;
    },
    async sendSms(send_ok) {
      if (!this.isPhoneValid) {
        this.$message({
          message: '请输入有效的手机号',
          type: 'error'
        });
        return;
      }
      if (!send_ok) {
        this.$message({
          message: response.data.msg || '发送验证码失败',
          type: 'error'
        });
        return;
      } else {
        this.$message({
          message: '发送验证码成功',
          type: 'success'
        });
      }
      this.startCountdown();
    },
    onBizResultCallback(bizResult) {
      if (bizResult === true) {
        console.log('验证码通过');
      } else {
        alert('业务验证不通过！');
      }
    },
    getInstance(instance) {
      this.captcha = instance;
    },
    startCountdown() {
      if (!this.isCounting) {
        this.isCounting = true;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
            this.isCounting = false;
            this.countdown = 60;
          }
        }, 1000);
      }
    },
    validatePhone() {
      this.phoneError = '';
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    async submit() {
      if (!this.isFormValid) {
        this.codeError = '请输入6位验证码';
        return;
      }
      
      try {
        const response = await api.login_sms({
          phone_num: this.phone_num,
          code: this.verificationCode
        });
        
        if (response.data.code === 0) {
          localStorage.setItem('token', response.data.data.token);
          EventBus.emit('user-logged-in');
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          this.isLoggedIn = true;
          this.closeLogin();
          this.$router.push('/');
        } else {
          this.$message({
            message: response.data.msg || '登录失败',
            type: 'error'
          });
        }
      } catch (error) {
        this.$message({
          message: '登录失败，请稍后重试',
          type: 'error'
        });
      }
    },
    async login_phone() {
      api.login_phone({ phone_num: this.phone_num, password: this.password })
        .then(response => {
          if (response.data.code !== 0) {
            this.$message({
              message: '登录失败',
              type: 'error'
            });
          } else {
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            localStorage.setItem('token', response.data.data.token);
            EventBus.emit('user-logged-in');
            this.$router.push('/');
          }
        });
    },
    toggleLoginMode() {
      this.loginMode = this.loginMode === 'code' ? 'password' : 'code';
    },
    qqLogin() {
      api.qqLoginPath()
        .then(response => {
          if (response.data.code !== 0) {
            this.$message({
              message: response.data.msg || '获取QQ登录授权地址失败',
              type: 'error'
            });
          } else {
            window.location.href = response.data.data;
          }
        });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped>
.login-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  backdrop-filter: blur(2px);
  transition: opacity 0.3s ease;
  /* position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000; */
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
  margin: 0;
  position: relative;
  animation: popIn 0.3s ease-out;
}

@keyframes popIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.welcome-text {
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
  font-size: 1.8rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.input-group {
  display: flex;
  gap: 0.5rem;
  position: relative;
}

.country-select {
  width: 80px;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #f8f9fa;
}

.phone-input,
.verification-input,
.password-input {
  flex: 1;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.phone-input:focus,
.verification-input:focus,
.password-input:focus {
  border-color: #4a90e2;
  outline: none;
}

.verification-group {
  position: relative;
}

.verify-button {
  padding: 0.75rem 1rem;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.verify-button:hover:not(.disabled) {
  background: #357abd;
}

.verify-button.disabled {
  background: #ccc;
  cursor: not-allowed;
}

.submit-button {
  width: 100%;
  padding: 0.75rem;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover:not(.disabled) {
  background: #357abd;
}

.submit-button.disabled {
  background: #ccc;
  cursor: not-allowed;
}

.login-options {
  margin-top: 1.5rem;
  text-align: center;
}

.toggle-mode-button {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.5rem;
}

.toggle-mode-button:hover {
  text-decoration: underline;
}

.social-login {
  margin-top: 1.5rem;
}

.social-text {
  color: #666;
  margin-bottom: 0.5rem;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: transform 0.3s;
}

.icon:hover {
  transform: scale(1.1);
}

.error-message {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.error {
  border-color: #ff4d4f !important;
}

.phone-input.error,
.verification-input.error,
.password-input.error {
  border-color: #ff4d4f;
  transition: border-color 0.3s;
}

.password-group {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  cursor: pointer;
  font-size: 0.8rem;
}

.password-toggle:hover {
  color: #4a90e2;
}

/* 移除之前的body样式 */
:deep(body) {
  margin: 0;
  padding: 0;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: #f5f5f5;
  color: #666;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 1001;
}

.close-button:hover {
  background: #e0e0e0;
  color: #333;
}

#captcha-element {
  position: fixed;
  top: -9999px;
  left: -9999px;
  visibility: hidden;
}
</style>
